/* Carrousel op basis van Flickity (dezelfde library die de slideshow gebruikt).
   Elke container met [data-product-carousel] wordt een carrousel.
   Werkt met de bestaande .grid__item-cellen, dus de kaart-opmaak blijft
   identiek aan de rest van de site. */
(function () {
  function buildOptions(el) {
    return {
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      wrapAround: false,
      pageDots: el.getAttribute('data-carousel-dots') === 'true',
      prevNextButtons: true,
      adaptiveHeight: false,
      dragThreshold: 8,
      rightToLeft: (window.theme && theme.config && theme.config.rtl) || false
    };
  }

  function relayout(flkty) {
    if (!flkty) return;
    flkty.reloadCells();
    flkty.resize();
  }

  // AOS zet een eigen transform/opacity op elementen met [data-aos]. Op de
  // carrousel-cellen botst die transform met Flickity's positionering (cellen
  // stapelen dan op elkaar). Binnen de carrousel schakelen we AOS daarom uit.
  function neutralizeAos(el) {
    var nodes = el.querySelectorAll('[data-aos]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].removeAttribute('data-aos');
      nodes[i].style.opacity = '';
      nodes[i].style.transform = '';
    }
  }

  function initOne(el) {
    if (!el || el.classList.contains('flickity-enabled')) return;
    if (typeof Flickity === 'undefined') return;
    // Eén cel of minder: geen carrousel nodig.
    if (el.children.length < 2) return;
    neutralizeAos(el);
    var flkty = new Flickity(el, buildOptions(el));

    // Flickity kan bij initialisatie celbreedtes verkeerd meten wanneer
    // afbeeldingen nog niet geladen zijn (cellen komen dan over elkaar).
    // Daarom meten we opnieuw zodra alles binnen is.
    var imgs = el.querySelectorAll('img');
    var pending = 0;
    function onImg() { pending -= 1; if (pending <= 0) relayout(flkty); }
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) {
        pending += 1;
        imgs[i].addEventListener('load', onImg);
        imgs[i].addEventListener('error', onImg);
      }
    }
    // Extra hermetingen: kort na init (fonts/CSS) en na volledige paginalaadtijd.
    setTimeout(function () { relayout(flkty); }, 250);
    window.addEventListener('load', function () { relayout(flkty); });
  }

  function initAll(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('[data-product-carousel]');
    for (var i = 0; i < nodes.length; i++) {
      initOne(nodes[i]);
    }
  }

  function destroyIn(scope) {
    var nodes = scope.querySelectorAll('[data-product-carousel]');
    for (var i = 0; i < nodes.length; i++) {
      var fl = (typeof Flickity !== 'undefined') && Flickity.data(nodes[i]);
      if (fl) fl.destroy();
    }
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // Ondersteuning voor de thema-editor (secties opnieuw laden/verwijderen).
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyIn(e.target); });
})();
